import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

import Login from './views/Login';
import Layout from './views/Layout';
import Home from './views/Home/Home';
import Order from './views/Order/Order';
import Forbruk from './views/Forbruk/Forbruk';
import Faktura from './views/Faktura/Faktura';
import Profil from './views/Profil/Profil';
import PersonalInformation from './views/Profil/PersonalInformation';
import ContactInformation from './views/Profil/ContactInformation';
import ContractInformation from './views/Profil/ContractInformation';
import ResetPassword from './views/Profil/ResetPassword';
import NewContract from './views/NewContract/NewContract';
import Meldinger from './views/Meldinger/Meldinger';
import Melding from './views/Meldinger/Melding';
import AuthService from './utils/msal';
import jwt_decode from 'jwt-decode';

const routes = [
  {
    path: '/login',
    component: Login,
    name: 'Login',
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: '/home',
        component: Home,
      },
      {
        path: '/forbruk',
        component: Forbruk,
      },
      {
        path: '/forbruk/:guid',
        component: Forbruk,
      },
      {
        path: '/faktura',
        component: Faktura,
      },
      {
        path: '/meldinger',
        component: Meldinger,
      },
      {
        path: '/meldinger/:slug',
        component: Melding,
      },
      {
        path: '/profil',
        component: Profil,
      },
      {
        path: '/profil/personal',
        component: PersonalInformation,
      },
      {
        path: '/profil/contact',
        component: ContactInformation,
      },
      {
        path: '/profil/contact/:guid',
        component: ContactInformation,
      },
      {
        path: '/profil/contract',
        component: ContractInformation,
      },
      {
        path: '/profil/password',
        component: ResetPassword,
      },
      {
        path: '/order',
        component: Order,
      },
      {
        path: '/add-contract',
        component: NewContract,
      },
    ],
  },
];

const Router = new VueRouter({
  routes,
});

Router.beforeEach(async (to, from, next) => {
  const Auth = new AuthService();

    if(localStorage.getItem("redirectInProgress") && localStorage.getItem("redirectInProgress") == "true"){
        localStorage.removeItem("redirectInProgress");

        try{
            let tokenResponse = await AuthService.app.handleRedirectPromise();

            if (tokenResponse !== null && Auth.isLogIn()) {
                console.log(tokenResponse);
                localStorage.customToken = tokenResponse.idToken;
                var decoded = jwt_decode(tokenResponse.idToken);
                localStorage.setItem("expire",decoded.exp);
                next("/");
            }else{
                console.log("Invalid response from redirect");
                Auth.logout();
            }
        }catch(error){
            console.log(error);
            if(error.errorMessage.indexOf('AADB2C90118') !== -1){
                const auth = new AuthService();
                auth.forgotPassword();
            }else{
                Auth.logout();
            }
        }
    }else{
        if (to.fullPath !== '/login') {
            if (!Auth.isLogIn()) {
                next("/login");
            }else{
                next();
            }
        }else{
            next();
        }
    }
});

export default Router;